import QuerySettingsModal from './QuerySettingsModal';

export default QuerySettingsModal;
